/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface IncustControllersClientClientCouponClientAddRequestApiModel {
  /**
   * Code sring
   */
  code: string;
  /**
   * Type of code
   */
  type?: IncustControllersClientClientCouponClientAddRequestApiModelTypeEnum;
}
export enum IncustControllersClientClientCouponClientAddRequestApiModelTypeEnum {
  Coupon = 'coupon',
  CouponBatch = 'coupon-batch',
  GiftCard = 'gift-card',
  Other = 'other'
}
